export default __webpack_public_path__ + "img/cec929b8694e12835ce0c2bc7c751f20.svg";